"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bulkEditOperationTypesToBulkAssertionTypes = exports.bulkEditOperationTypesToMessageKey = exports.bulkEditOperationTypes = exports.BulkEditOperationTypes = void 0;
const proposal_1 = require("../../../client/proposal");
var BulkEditOperationTypes;
(function (BulkEditOperationTypes) {
    BulkEditOperationTypes["Replace"] = "replace";
    BulkEditOperationTypes["Merge"] = "merge";
    BulkEditOperationTypes["Delete"] = "delete";
})(BulkEditOperationTypes || (exports.BulkEditOperationTypes = BulkEditOperationTypes = {}));
exports.bulkEditOperationTypes = Object.values(BulkEditOperationTypes);
exports.bulkEditOperationTypesToMessageKey = {
    [BulkEditOperationTypes.Replace]: 'BULK_EDIT_ATTRIBUTES_DIALOG_OPERATION_REPLACE',
    [BulkEditOperationTypes.Merge]: 'BULK_EDIT_ATTRIBUTES_DIALOG_OPERATION_MERGE',
    [BulkEditOperationTypes.Delete]: 'BULK_EDIT_ATTRIBUTES_DIALOG_OPERATION_DELETE',
};
exports.bulkEditOperationTypesToBulkAssertionTypes = {
    [BulkEditOperationTypes.Replace]: proposal_1.BulkAssertionOperationTypes.Replace,
    [BulkEditOperationTypes.Merge]: proposal_1.BulkAssertionOperationTypes.Merge,
    [BulkEditOperationTypes.Delete]: proposal_1.BulkAssertionOperationTypes.Delete,
};
